import React from "react";

const Panels = ({ children }: { children: React.ReactNode[] }) => {
	

	console.log("panels", children);

	return (
		<div className="flex flex-row h-full w-full bg-white text-base">
			{children[0]}
			{children.length >= 2 && children[1] !== null && <div className="flex justify-center items-center flex-[.8]">{children[1]}</div>}
		</div>
	);
};

export default Panels;
